import apiStore from './index';
import { paths }  from '@src/consts/apiPaths';
const logger = Logger.get('rules api')

const hitRuleEngineApi = async ( payload = {} ) => {

    try {

        const path = paths.rewards ;

        let { data: body } = await apiStore.axios.post( path, { ...payload } );
        
        logger.log( 'rewards success: ', body )

    }
    catch( error ){
        logger.log( error );
    } 
}

export default hitRuleEngineApi ;